import SidebarPanel from '@/components/layout/SidebarPanel.tsx';

export default function Sidebar() {
  return (
    <div className="mx-3 sticky top-3 my-3 h-[calc(100svh-24px)] overflow-hidden">
      <SidebarPanel />
    </div>
  );
}
